export enum EOrderApiTabValues {
    PersonalizedData = 'personalized',
    ComprehensiveProductInformation = 'comprehensive',
    StockAvailabilityUpdates = 'stock',
}

export enum VictronWebsiteApiTabValues {
    ProductInformation = 'product_information',
    ProductPhotos = 'product_photos',
    ProductDocuments = 'product_documents',
}
